let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bpz8j")).then(() => parcelRequire('8pclD'));